import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

import { PROFILE_EDIT_PATHNAME } from '@glass/common/modules/pages/paths';
import IconButton from '@glass/web/components/base/IconButton';
import Menu from '@glass/web/components/base/Menu';
import EditRounded from '@glass/web/components/base/icons/EditRounded';
import ExitToAppRounded from '@glass/web/components/base/icons/ExitToAppRounded';
import MoreVertRounded from '@glass/web/components/base/icons/MoreVertRounded';

import Link from '@glass/shared/components/Link/Link';
import IconMenuItem from '@glass/shared/components/Profile/IconMenuItem';
import signOutUserAction from '@glass/shared/modules/auth/signOutUserAction';

function ProfileCardMenu() {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = useCallback((evt) => {
    evt.stopPropagation();
    setAnchorEl(evt.currentTarget);
  }, []);

  const handleClose = useCallback((evt) => {
    evt?.stopPropagation();
    setAnchorEl(null);
  }, []);

  const dispatch = useDispatch();
  const handleSignOut = useCallback(
    (evt) => {
      handleClose(evt);
      dispatch(signOutUserAction());
    },
    [dispatch, handleClose],
  );

  return (
    <>
      <IconButton size="large" onClick={handleClick}>
        <MoreVertRounded />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        open={!!anchorEl}
        onClose={handleClose}
      >
        <IconMenuItem
          icon={<ExitToAppRounded fontSize="small" />}
          title="Sign out"
          onClick={handleSignOut}
        />
        <IconMenuItem
          component={Link}
          href={PROFILE_EDIT_PATHNAME}
          icon={<EditRounded fontSize="small" />}
          title="Manage"
          onClick={handleClose}
        />
      </Menu>
    </>
  );
}

export default ProfileCardMenu;
